import React, { ForwardedRef } from 'react';
import {
  Input, InputGroup, InputProps, Loader,
} from 'rsuite';

interface Props extends InputProps {
  loading?: boolean;
}

function renderPartnerCodeInput(
  { loading, ...props }: Props,
  ref: ForwardedRef<HTMLInputElement>,
): JSX.Element {
  return (
    <InputGroup inside>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <Input {...props} ref={ref} />
      {loading && (
        <InputGroup.Addon>
          <Loader />
        </InputGroup.Addon>
      )}
    </InputGroup>
  );
}

const PartnerCodeInput = React.forwardRef(renderPartnerCodeInput);

PartnerCodeInput.defaultProps = {
  loading: false,
};

export default PartnerCodeInput;
